import React from 'react';
import { ReactComponent as Logo } from '~/assets/images/Logo.svg';

function PoweredByAdvieskeuze() {
  return (
    <div className="py-4 flex flex-column md:flex-row items-center justify-center gap-2.5">
      <span className="text-sm">Powered by</span>
      <Logo className="w-[160px]" />
    </div>
  );
}

export default PoweredByAdvieskeuze;